const componentObj = {
  transclude: true,
  controller: 'PanelCtrl',
  template:
    `<div class="panels__panel" ng-show="$ctrl.panel.selected">
      <div class="panel-title">
        <h6 class="uppercase">{{:: $ctrl.titleToken | translate}}</h6>
        <i class="fa fa-times"
           ng-click="$ctrl.closePanel()">
        </i>
      </div>
      <div class="panel-scroll-container">
        <div class="panel-scroll-container__child p1" ng-transclude></div>
      </div>
    </div>`,
  require: {
    parent: '^^panels'
  },
  bindings: {
    icon: '@',
    titleToken: '@',
    name: '@'
  }
};

function PanelCtrl() {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.panel = {
      selected: false,
      name: ctrl.name,
      icon: ctrl.icon,
      titleToken: ctrl.titleToken
    };

    ctrl.parent.addPanel(ctrl.panel);
  };

  ctrl.closePanel = () => {
    ctrl.parent.togglePanel(ctrl.panel);
  };
}

export default function (ngModule) {
  ngModule.component('panel', componentObj);
  ngModule.controller('PanelCtrl', PanelCtrl);
}
